import BomListComponent from "./screens/Bom/bom-list.component";
import CartComponent from "./screens/Cart/cart.component";
import HomePageComponent from "./screens/Home-Page/home-page.component";
import InventoryComponent from "./screens/Inventory-Page/inventory.component";
import LoginComponent from "./screens/Login/login.component";
import NewProjectComponent from "./screens/New-Projects/new-project.component";
import ProductListComponent from "./screens/Products-list/product-list.component";
import ProductsComponent from "./screens/Products-Page/products.component";
import SignupComponent from "./screens/Signup/signup.component";
import CategoryListComponent from "./screens/Category-list/category-list.component";
import AccountComponent from "./screens/Account-Page/account.component";
import OrderStatusComponent from "./screens/Order-status/order-status.component";
import OrderDetailsComponent from "./screens/Order-Details/order-details.component";
import BomColumnMappingComponent from "./screens/Bom-Column-Mapping/column-mapping.component";
import BomToolIndexComponent from "./screens/Bom-Tool/bom-tool.component";
import AboutUsComponent from "./screens/About-Us/about-us.component";
import ContactUsComponent from "./screens/Contact-Us/contact-us.component";
import RequestQuoteComponent from "./screens/Request-Quote/request-quote.component";
import CommonPagesComponent from "./screens/Pages/common-pages.component";
import ProductSearchDetail from "./screens/Product-search-Detail/product-search-detail.component";
import ProductDetailsComponent from "./screens/Product-Details/product-details.template";

const appRoutes = [
  {
    path: "/",
    element: <HomePageComponent />,
    title: "Home - Semisearch Ecommerce",
  },
  {
    path: "/login",
    element: <LoginComponent />,
    title: "Login - Semisearch Ecommerce",
  },
  {
    path: "/register",
    element: <SignupComponent />,
    title: "Register - Semisearch Ecommerce",
  },
  {
    path: "/new-projects",
    element: <NewProjectComponent />,
    title: "New Project - Semisearch Ecommerce",
  },
  {
    path: "/cart",
    element: <CartComponent />,
    title: "Cart - Semisearch Ecommerce",
  },
  {
    path: "/bom-list",
    element: <BomListComponent />,
    title: "BOM List - Semisearch Ecommerce",
  },
  {
    path: "/product/:partNumber",
    element: <ProductsComponent />,
    title: "Product - Semisearch Ecommerce",
  },
  {
    path: "/inventory/:uniqueId",
    element: <InventoryComponent />,
    title: "Inventory - Semisearch Ecommerce",
  },
  // {
  //   path: "/product-list",
  //   element: <ProductListComponent />,
  //   title: "Products - Semisearch Ecommerce",
  // },
  {
    path: "/product-list/:slug",
    element: <ProductDetailsComponent />,
    title: "Products - Semisearch Ecommerce",
  },
  {
    path: "/product-search/:partNumber",
    element: <ProductSearchDetail />,
    title: "Products - Semisearch Ecommerce",
  },
  {
    path: "/category-list",
    element: <CategoryListComponent />,
    title: "Categories - Semisearch Ecommerce",
  },
  {
    path: "/account/orders",
    element: <AccountComponent />,
    title: "My Orders - Semisearch Ecommerce",
  },
  {
    path: "/account/order-details/:orderId",
    element: <OrderDetailsComponent />,
    title: "Order Details - Semisearch Ecommerce",
  },
  {
    path: "/account",
    element: <AccountComponent />,
    title: "My Account - Semisearch Ecommerce",
  },
  {
    path: "/order-status/:orderId",
    element: <OrderStatusComponent />,
    title: "Order Status - Semisearch Ecommerce",
  },
  {
    path: "/bom-column-mapping/:id",
    element: <BomColumnMappingComponent />,
    title: "BOM Column Mapping - Semisearch Ecommerce",
  },
  {
    path: "/bom-tool/:id",
    element: <BomToolIndexComponent />,
    title: "BOM Tool - Semisearch Ecommerce",
  },
  {
    path: "/about-us",
    element: <AboutUsComponent />,
    title: "About Us - Semisearch Ecommerce",
  },
  {
    path: "/contact-us",
    element: <ContactUsComponent />,
    title: "Contact Us - Semisearch Ecommerce",
  },
  {
    path: "/request-quote",
    element: <RequestQuoteComponent />,
    title: "Request a Quote - Semisearch Ecommerce",
  },
  {
    path: "/page/privacy-policy",
    element: <CommonPagesComponent slug="privacy-policy" />,
    title: "Privacy Policy - Semisearch Ecommerce",
  },
  {
    path: "/page/return-policy",
    element: <CommonPagesComponent slug="return-policy" />,
    title: "Return Policy - Semisearch Ecommerce",
  },
  {
    path: "/page/terms-and-conditions",
    element: <CommonPagesComponent slug="terms-and-conditions" />,
    title: "Terms & Conditions - Semisearch Ecommerce",
  },
];

export default appRoutes;
